/**
 * Takes a groupName and object of values (e.g. { key: 'value' }) and prints them to the console grouped by the groupName and as key, value for identification
 *
 * @param {string} groupName - The name of the group to show in the console
 * @param {object} values - The object of values to show.
 */
export const consoleLogGroup = (groupName, values) => {
  console.group(groupName)
  for (var key in values) {
    console.log(key, values[key])
  }
  console.groupEnd()
}

// console.logGrouped = () => {
//   console.group(arguments[0])
//   let values = arguments[1]
//   for (var key in values) {
//     console.log(key, values[key])
//   }
//   console.groupEnd()
// }



// WEBPACK FOOTER //
// ./src/helpers/consolelog.js